module.exports = __webpack_public_path__ + "img/copyBlue.821d7cf9.svg";